import type { Paragraph } from '@/api/types/stowed-element'
import type { TextBoxData } from '@/lib/text/types/text-box-data'

export function collectFontFamilyIdsFromParagraphs(paragraphs: Paragraph[] | undefined): number[] {
  if (!paragraphs?.length) return []
  const ids = new Set<number>()

  for (const p of paragraphs) {
    for (const line of p.textLines ?? []) {
      for (const run of line.textRuns ?? []) {
        if (run.fontFamilyId != null) ids.add(run.fontFamilyId)
      }
    }
  }

  return [...ids]
}

/** Distinct font family ids referenced by any run in the given text boxes. */
export function collectFontFamilyIdsFromTextBoxes(textBoxes: TextBoxData[]): Set<number> {
  const out = new Set<number>()

  for (const box of textBoxes) {
    for (const id of collectFontFamilyIdsFromParagraphs(box.paragraphs)) {
      out.add(id)
    }
  }

  return out
}
